import { Space } from "antd";
import { useTranslation } from "react-i18next";

import { ModelLink } from "@/modules/model-link";

const RecommendedBy = ({ recommendedBy, loading }) => {
  const { t } = useTranslation();

  if (!recommendedBy || loading) return null;

  const firstObservation = recommendedBy.observations?.[0];

  return (
    <Space>
      {t("recommendation:recommendedBy.label")}
      <ModelLink
        model="intervention"
        item={recommendedBy}
        search={`?observation_id=${firstObservation}`}
      />
    </Space>
  );
};

export default RecommendedBy;
